import { render, staticRenderFns } from "./Kurtosis.vue?vue&type=template&id=83e96122&scoped=true"
import script from "./Kurtosis.vue?vue&type=script&lang=js"
export * from "./Kurtosis.vue?vue&type=script&lang=js"
import style0 from "./Kurtosis.vue?vue&type=style&index=0&id=83e96122&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83e96122",
  null
  
)

export default component.exports